import React, { PureComponent, Fragment } from 'react';
import { Header } from 'semantic-ui-react';
import { withApi } from '../../context/AppContext';
import Table from '../../components/Table';
import { APP_URL } from '../../constants';

class OrderPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      downloading: false,
    };
    this.download = document.createElement('a');
  }
  renderDealerTable = () => {
    const { orderData } = this.props;
    if (!orderData.metadata.dealer) return;
    const body = Object.entries(orderData.metadata.dealer).map(info => [
      info[0].toUpperCase(),
      info[1],
    ]);
    return <Table title="Dealer Info" body={body} />;
  };

  renderCustomTable = () => {
    const { orderData } = this.props;
    const body = Object.entries(orderData.customer).map(info => [
      info[0].toUpperCase(),
      String(info[1]),
    ]);
    return <Table title="Client Info" body={body} />;
  };

  renderBOM = () => {
    const { bom } = this.props.orderData.metadata;
    const { downloading } = this.state;
    const header = ['Part #', 'Description', 'List Price', 'Qty'];
    const body = bom.map(item => [
      item.partNumber,
      item.description,
      `$${item.listPrice}`,
      item.qty,
    ]);
    return (
      <Fragment>
        <Table title="BOM" header={header} body={body} />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button
            className={`submitButton${downloading ? ' disabled' : ''}`}
            onClick={this.onDownloadItemList}
            disabled={downloading}
          >
            {downloading ? 'DOWNLOADING' : 'DOWNLOAD ITEMLIST'}
          </button>
          <button
            className={`submitButton${downloading ? ' disabled' : ''}`}
            onClick={this.onDownloadDrawing}
            disabled={downloading}
          >
            {downloading ? 'DOWNLOADING' : 'DOWNLOAD DRAWING'}
          </button>
        </div>
      </Fragment>
    );
  };

  onDownloadItemList = async () => {
    const { orderData } = this.props;
    const { downloading } = this.state;
    const reference = 'CFG4' + ('0000' + orderData.sequenceValue).slice(-4);
    if (downloading) return;
    this.setState({ downloading: true });
    const pdfData = await fetch(
      `${APP_URL}/order/itemListFromHash/${orderData.hash}`
    ).then(res => res.blob());
    const file = window.URL.createObjectURL(pdfData);
    this.download.href = file;
    this.download.download = `BOSTONtec Product List Ref# ${reference}.pdf`;
    this.download.click();
    window.URL.revokeObjectURL(file);
    this.setState({ downloading: false });
  };

  onDownloadDrawing = async () => {
    const { orderData } = this.props;
    const { downloading } = this.state;
    const reference = 'CFG4' + ('0000' + orderData.sequenceValue).slice(-4);
    if (downloading) return;
    this.setState({ downloading: true });
    const pdfData = await fetch(
      `${APP_URL}/order/drawingFromHash/${orderData.hash}`
    ).then(res => res.blob());
    const file = window.URL.createObjectURL(pdfData);
    this.download.href = file;
    this.download.download = `BOSTONtec Drawing Ref# ${reference}.pdf`;
    this.download.click();
    window.URL.revokeObjectURL(file);
    this.setState({ downloading: false });
  };

  renderSummary = () => {
    const { bom, dealer } = this.props.orderData.metadata;
    const totalPrice = bom.reduce(
      (price, item) => price + item.listPrice * item.qty,
      0
    );
    const body = [
      ['Total Items', bom.length],
      ['Total List Price', `$${totalPrice}`],
    ];
    if (dealer)
      body.push(['Dealer Price', `$${totalPrice * (1 - dealer.discount)}`]);

    return <Table title="Summary" body={body} />;
  };

  renderPresetLink = () => {
    const { orderData } = this.props;
    const link = `${APP_URL}/?hash=${orderData.hash}`;
    return (
      <Fragment>
        <Header className="header" as="h2">
          Preset
        </Header>
        <a href={link} target="_blank">
          {link}
        </a>
      </Fragment>
    );
  };

  render() {
    const { appApi } = this.props;

    if (!appApi) return <div className="configuration-not-loaded" />;
    return (
      <Fragment>
        {this.renderCustomTable()}
        {this.renderBOM()}
        {this.renderDealerTable()}
        {this.renderSummary()}
        {this.renderPresetLink()}
      </Fragment>
    );
  }
}

export default withApi(OrderPanel);



// WEBPACK FOOTER //
// ./src/containers/OrderPanel/index.js